<template>
    <div class="stay_list">
        <div class="items_title" v-if="mold"><i class="iconfont iconicon_dianpu"></i><span>{{ invoice.shopName }}</span></div>
        <div class="stay_list_top">
            <van-checkbox v-if="mold" icon-size='20px' checked-color='#FF7A45' v-model="invoice.checked" @change='onChecked(invoice)'>
                {{ invoice.deliveryOrderNo }}
            </van-checkbox>
            <span v-else>{{ invoice.deliveryOrderNo }}</span>
            <span>{{ filterStatus(status) }}</span>
        </div>
        <div class="stay_list_center">
            <div class="iclc" v-for="item in invoice.products" :key="item.productId">
                <div class="iclc_img">
                    <img :src="item.productPictureUrl" alt="">
                </div>
                <div class="iclc_content">
                    <div class="iclc_content_name" v-text="item.skuShowName"></div>
                    <div class="iclc_content_bot">
                        <div class="iclc_content_bot_price"><sub>¥</sub> {{ item.finalPrice | NumFormat }}</div>
                        <div class="iclc_content_bot_num"><sub>X</sub>{{ item.shippedQuantity }}</div>
                    </div>
                </div>
            </div>
        </div>
        <div class="stay_list_info" v-if="mold && invoice.rejectReason">拒审原因：{{ invoice.rejectReason }}</div>
        <div class="stay_list_bottom">
            共{{ invoice.productCount }}件 合计：¥{{ invoice.deliveryFinalTotalAmount | NumFormat }}
        </div>
    </div>
</template>

<script>
export default {
    props: {
        invoice: {
            type: Object,
            default: () => {
                return {}
            }
        },
        mold: {
            type: Boolean,
            default: true
        },
        status: {
            type: Number,
            default: null
        }
    },
    methods: {
        filterStatus (value) {
            switch (value) {
                case 10:
                    return '审核中'
                case 20:
                    return '审核中'
                case 30:
                    return '已开票'
                case 0:
                    return '已拒审'
                default:
                    return '待开票'
            }
        },
        onChecked () {
            this.$emit('onChecked')
        }
    }
}
</script>

<style lang="scss" scoped>
.stay {
    &_list {
        margin-bottom: 20px;
        background-color: #fff;
        border-radius: 8px;
        &_top {
            display: flex;
            justify-content: space-between;
            height: 64px;
            line-height: 64px;
            font-size: 26px;
            border-bottom: 2px solid #ededf0;
            padding: 0 24px;
            span {
                color: #ff7a45;
                &:first-child {
                    color: #333;
                }
            }
        }
        .items_title {
            font-size: 28px;
            padding: 32px 24px 0;
            display: -webkit-box;
            -webkit-box-orient: vertical;
            -webkit-line-clamp: 1;
            overflow: hidden;
            white-space: normal;
            word-break: break-all;
            span {
                margin-left: 8px;
                color: #000;
            }
        }
        &_info {
            font-size: 24px;
            padding: 8px 24px 24px;
            color: #ff7a45;
        }
        &_center {
            .iclc {
                box-sizing: border-box;
                padding: 24px 0 24px 0;
                margin-left: 24px;
                display: flex;
                justify-self: start;
                &:not(:last-child) {
                    border-bottom: 2px solid #ededf0;
                }
                &_img {
                    flex: 0 0 180px;
                    height: 180px;
                    border: 2px solid #ededf0;
                    border-radius: 16px;
                    font-size: 0;
                    position: relative;
                    display: flex;
                    img {
                        display: inline-block;
                        margin: 0 auto;
                        background: #f2f3f5;
                        object-fit: cover;
                        justify-self: center;
                        align-self: center;
                    }
                }
                &_content {
                    width: 100%;
                    display: flex;
                    align-content: space-between;
                    flex-wrap: wrap;
                    margin-left: 24px;
                    padding-right: 24px;
                    color: #333;
                    &_name {
                        font-size: 28px;
                        line-height: 40px;
                        flex: 0 0 100%;
                        display: -webkit-box;
                        -webkit-box-orient: vertical;
                        -webkit-line-clamp: 2;
                        overflow: hidden;
                        white-space: normal;
                        word-break: break-all;
                    }
                    &_bot {
                        flex: 1;
                        display: flex;
                        justify-content: space-between;
                        font-size: 30px;
                        color: #000;
                        sub {
                            font-size: 20px;
                        }
                    }
                }
            }
        }
        &_bottom {
            padding: 24px;
            font-size: 28px;
            text-align: right;
            border-top: 2px solid #ededf0;
        }
    }
}
/deep/ .iconfont {
    font-size: 32px;
    vertical-align: bottom;
    color: #999;
}
</style>
